export default __webpack_public_path__ + "static/media/074-rhinoceros.f5d74709.svg";